import { Link, Outlet, useLocation } from "react-router-dom";
import { ShoppingBasket } from "lucide-react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { OwnerTestingBanner } from "@/components/layout/OwnerTestingBanner";
import { useBasket } from "@/lib/BasketContext";
import { gbp } from "@/lib/api";

export const Layout = () => {
  const { count, subtotalPence } = useBasket();
  const { pathname } = useLocation();
  // never cover the basket/checkout/order pages with the sticky basket bar
  const hideStickyBar = ["/basket", "/checkout", "/order"].some((p) => pathname.startsWith(p));

  return (
    <div className="flex min-h-screen flex-col bg-choco">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-gold focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-choco"
        data-testid="skip-to-content-link"
      >
        Skip to content
      </a>
      <Header />
      <OwnerTestingBanner />
      <main id="main-content" className="flex-1 pt-16 sm:pt-20">
        <Outlet />
      </main>
      <Footer />
      {count > 0 && !hideStickyBar && (
        <Link
          to="/basket"
          className="fixed bottom-4 left-4 right-4 z-40 flex items-center justify-between rounded-full bg-gold px-5 py-3.5 text-sm font-bold text-choco shadow-lg shadow-black/40 transition-transform active:scale-[0.98] md:hidden"
          data-testid="mobile-sticky-basket-button"
        >
          <span className="inline-flex items-center gap-2">
            <ShoppingBasket className="h-4 w-4" aria-hidden="true" />
            View basket ({count})
          </span>
          <span>{gbp(subtotalPence)}</span>
        </Link>
      )}
    </div>
  );
};
